import { render } from "./UserManagementDisableAccountDialog.vue?vue&type=template&id=21cab79b"
import script from "./js/userManagementDisableAccountDialog.js?vue&type=script&lang=js&external"
export * from "./js/userManagementDisableAccountDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__